module.exports = "https://cdn.hellotech.com/client-assets/Okyo-logo_6f3a17cc49102bfc5e0df81a2d8ee0f9.svg";